<template>
  <div>
    <el-form
      :model="Detaildata"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%;margin:20px auto; "
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="标题" prop="title">
            <el-input
              clearable
              placeholder="请输入内容"
              v-model="Detaildata.title"
             
               :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="10">
          <el-form-item label="视频的地址" prop="ossUrl">
            <el-input clearable placeholder="请输入内容" v-model="toEdDas.ossUrl" />
          </el-form-item>
        </el-col>-->
        <el-col :span="10">
          <el-form-item label="作者" prop="authorId">
            <el-select
              clearable
              placeholder="请选择"
              v-model="Detaildata.authorId"
              :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            >
              <el-option
                v-for="item in author"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

       
        <el-col :span="10">
          <el-form-item label="是否上轮播" prop="isRotation">
            <el-select
              clearable
              placeholder="请选择"
              v-model="Detaildata.isRotation"
              :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in isLun"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          
          <el-form-item label="猜你喜欢" prop="isHomeRotation">
            <el-select
              clearable
              placeholder="请选择"
              v-model="Detaildata.isLike"
             :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in isOrnot"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
         <el-col :span="19">
          <el-form-item label="摘要" prop="remark">
            <el-input
            type="textarea"
             :rows="10"
              clearable
              placeholder="请输入内容"
              v-model="Detaildata.remark"
              :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            />
        
          </el-form-item>
        </el-col>
      </el-row>
  
      <el-row>
        <el-col :span="10">
          <el-form-item label="视频文件" prop="ossUrl">
            <el-upload
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-change="videoUp"
              :on-success="AudioListSuccess"
              :show-file-list="false"
              action="https://jsonplaceholder.typicode.com/posts/"
              class="audio-upt"
              ref="uptImg"
             :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            >
              <video :src="Detaildata.ossUrl" class="video" controls="controls" v-if="Detaildata.ossUrl" :poster="Detaildata.frontCoverUrl"></video>
              <i
                class="el-icon-plus avatar-uploader-icon"
                style="marginTop:5px;font-size: 50px;"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="视频封面图" prop="imgUrl">
            <el-upload
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-change="imgUp"
              :on-success="VideoSuccess"
              :show-file-list="false"
              action="https://jsonplaceholder.typicode.com/posts/"
              class="video_uptImg"
             :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen  ? true :false"
            >
              <img :src="Detaildata.frontCoverUrl" class="avatar" v-if="Detaildata.frontCoverUrl" />
              <i
                class="el-icon-plus avatar-uploader-icon"
                style="marginTop:65px;font-size: 50px;"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          @click="submitVideo('ruleForm')"
          style="margin-left: 200px"
          type="primary"
          :disabled="(Detaildata.examineStatus == 1 || Detaildata.examineStatus == 3) && allOpen && menuPerm('video:query') ? true :false"
     
        >保存</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import axios from "axios";
import {baseURL} from '../../api/config'
export default {
  data() {
    return {
      allOpen: true, //没有限制
      toEdDas: "", //修改的数据
      //审核状态：
      // examDas: [
      //   {
      //     value: "2",
      //     label: "未提交审核"
      //   },
      //   {
      //     value: "3",
      //     label: "审核中"
      //   },
      //   {
      //     value: "4",
      //     label: "审核未通过"
      //   },
      //   {
      //     value: "1",
      //     label: "审核通过"
      //   }
      // ],
      //--下拉框
      isOrnot: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],
      //   是否上轮播
      isLun: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 0,
          label: "不是"
        }
      ],
      TopicUptImg: [], //图片上传
      author: "" //作者
    };
  },
  mounted() {
    // var id=this.$route.query.data.id
    // // this.$route.query.data
    // this.postAxios("/video/update",{
    //   id:id,
    //   authorId:"",
    //   ossUrl:"",
    //   frontCoverUrl:"",
    //   commentCount:"",
    //   title:"",
    //   favorCount:"",
    //   isRotation:"",
    //   examineStatus:"",
    //   isLike:"",
    //   remark:""
    // }).then(res=>{
    //     console.log(res)
    // })
  },
    props: ["Detaildata"],
  created() {

    this.getAuthor(); //作者的数据
    // this.getZuo();
    // this.toEdDas = this.$route.query.data; //修改的数据
    this.toEdDas = this.Detaildata;
    console.log(this.Detaildata,'5555')
 


     if (this.menuPerm("video:edit_super") == true) {
      this.allOpen = false;
    }

  },
  methods: {
    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
         this.$message.error(res.message);
         this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },

    //作者：
    getZuo() {
      this.getAxios("/manager/list/userInfo", {
        managerId: this.toEdDas.authorId
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },

    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    // 图片上传
    imgUp(file, fileList) {
      console.log(file);
      this.TopicUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.TopicUptImg.push(resBase64);
        if (this.TopicUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.TopicUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toEdDas.frontCoverUrl = res.content[0]; //接口url参数
              this.TopicUptImg = [];
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
          
            if (!res.success && res.statusCode == "401") {
             this.$message.error(res.message);
             this.$router.push('/')
            }
          });
        }
      });
    },
    //上传成功：
    VideoSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    // 视频上传
    videoUp(file, fileList) {
      if (file) {
        let files = file.raw;

        let formdata = new FormData();
        formdata.append("img", files);
     
        axios
          .post(baseURL + "/file/uploadFile", formdata, {})
          .then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toEdDas.ossUrl = res.entity; //接口url参数
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (
              !res.success &&
              res.statusCode == "401" 
            ) {
             this.$message.error(res.message);
             this.$router.push('/')
            }
          });
      }
    },
    beforeUpload() {},
    //音频上传成功：
    AudioListSuccess(file, fileList) {
      this.$refs.uptImg.clearValidate();
    },
    submitVideo(formName) {
      var id = this.Detaildata.id;
      this.postAxios("/video/update", {
        id: id,
        authorId: this.toEdDas.authorId,
        ossUrl: this.toEdDas.ossUrl,
        frontCoverUrl: this.toEdDas.frontCoverUrl,
        // commentCount: this.toEdDas.commentCount,
        title: this.toEdDas.title,
        // favorCount: this.toEdDas.favorCount,
        isRotation: this.toEdDas.isRotation,
        // examineStatus: this.toEdDas.examineStatus,
        isLike: this.toEdDas.isLike,
        remark: this.toEdDas.remark
      }).then(res => {
        if (res.success) {
          this.$message.success(res.message);
        }
         else if (!res.success && res.statusCode == "401") {
             this.$message.error(res.message);
             this.$router.push('/')
            }else if(res.success==false){
              this.$message.error(res.message);
            }
       
      });
    }
  }
};
</script>
<style scoped lang="less">
/deep/ .el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  img {
    width: 150px;
    height: auto;
  }
  video {
    width: 150px;
    height: 150px;
  }
}

     /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;

        margin-top: 10px;
        margin-left: 10px;
      }

</style>